import { createFileRoute } from '@tanstack/react-router';
import { TabletsListPage } from '@/features/tablets/tablets-list-page.js';

export const Route = createFileRoute('/_app/tablets')({
  component: TabletsListPage,
});
